(function () {
  function initMobileNav() {
    document.querySelectorAll('slide-with-thumbs').forEach(function (el) {
      var container = el.querySelector('.media-main-swiper');
      if (!container || container.querySelector('.ss-mob-prev')) return;

      function makeBtn(dir) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ss-mob-arrow ss-mob-' + dir;
        btn.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
        btn.innerHTML =
          dir === 'prev'
            ? '<svg width="8" height="14" fill="none"><use href="#icon-back"/></svg>'
            : '<svg width="8" height="14" fill="none"><use href="#icon-next"/></svg>';
        btn.addEventListener('click', function () {
          var swiper = el.globalSlide;
          if (!swiper) return;
          if (dir === 'prev') swiper.slidePrev();
          else swiper.slideNext();
        });
        return btn;
      }

      container.appendChild(makeBtn('prev'));
      container.appendChild(makeBtn('next'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileNav);
  } else {
    initMobileNav();
  }
})();
